"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardRowData_vue_1 = __importDefault(require("@/client/components/card/CardRowData.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'CardRenderData',
    props: {
        renderData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CardRowData: CardRowData_vue_1.default,
    },
});
